import { render, staticRenderFns } from "./BlogHero.vue?vue&type=template&id=24082f0c&scoped=true&"
import script from "./BlogHero.vue?vue&type=script&lang=ts&"
export * from "./BlogHero.vue?vue&type=script&lang=ts&"
import style0 from "./BlogHero.vue?vue&type=style&index=0&id=24082f0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24082f0c",
  null
  
)

export default component.exports